"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBlsSignatures = void 0;
const misc_1 = require("@lit-protocol/misc");
/**
 * Get the BLS signatures from the response data.
 * @param responseData - The response data from BLS signature scheme.
 * @returns An array of BLS signatures.
 * @throws Error if no data is provided.
 */
function getBlsSignatures(responseData) {
    if (!responseData) {
        throw new Error('[getBlsSignatures] No data provided');
    }
    const signatureShares = responseData.map((s) => ({
        ProofOfPossession: s.signatureShare.ProofOfPossession,
    }));
    (0, misc_1.log)(`[getBlsSignatures] signatureShares:`, signatureShares);
    if (!signatureShares || signatureShares.length <= 0) {
        throw new Error('[getBlsSignatures] No signature shares provided');
    }
    return signatureShares;
    // const signedDataList = responseData.map((s) => s.dataSigned);
    // log(`[getBlsSignatures] signedDataList:`, signedDataList);
    // return signedDataList;
}
exports.getBlsSignatures = getBlsSignatures;
//# sourceMappingURL=get-bls-signatures.js.map